<style scope>
</style>

<template>
  <section class="container">
    <orcamento-piller-inativo-edit/>
  </section>
</template>

<script>
  import OrcamentoPillerInativoEdit from './piller/OrcamentoPillerInativoEdit'

  export default {
    components: {OrcamentoPillerInativoEdit},
    created () {
      if (!this.$store.state.parametros || !this.$store.state.parametros.id) {
        this.$air.sair()
        this.$root.$emit('acessar')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/orcamento/FormInativoEdit.vue